export const ButtonSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;
export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize];

export const ButtonType = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
} as const;
export type ButtonType = (typeof ButtonType)[keyof typeof ButtonType];

export const ButtonVariant = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
  TEXT: 'text',
} as const;
export type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant];

export const ButtonColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ERROR: 'error',
} as const;
export type ButtonColor = (typeof ButtonColor)[keyof typeof ButtonColor];
